
import $axios from '@/plugins/axiosInstance'

// import axios from 'axios';

// axios.defaults.withCredentials = true;

export default {

  login(user, userInputCaptha) {
    return $axios.post('Login', user, {
      withCredentials: true,
      headers: {

        'code': userInputCaptha,


      }
    });
  },
  
  kullaniciLogin(user, userInputCaptha) {
    return $axios.post('Login/KullaniciLogin', user, {
      withCredentials: true,
      headers: {

        'code': userInputCaptha,


      }
    });
  },
  async kullaniciBilgileri() {
    return $axios.get('Login/KullaniciBilgileri');
  },
  logout() {
    return $axios.get('Login/logout');
  },


};